import { render, staticRenderFns } from "./OrderReplaceModal.vue?vue&type=template&id=4f0f9e95&scoped=true&"
import script from "./OrderReplaceModal.vue?vue&type=script&lang=js&"
export * from "./OrderReplaceModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderReplaceModal.vue?vue&type=style&index=0&id=4f0f9e95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f9e95",
  null
  
)

export default component.exports